import * as React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Modal from 'react-responsive-modal';
import {
  displayDetailsPaymentButton,
  displayInvoice,
  displayRefundInformations,
  isBatAttenteValidation,
  isFichierAttenteValidation,
  renderAlert,
  renderCheque,
  renderClaim,
  renderContainerTrackingLink,
  renderCreditLinks,
  renderDateCommande,
  renderEtatCommande,
  renderFileButton,
  renderMontantTTC,
  renderNumCommande,
  renderOptionModeReglement,
} from './RenderCommon';
import { getShopRefInStorage, getUserId } from './MonCompteAction';
import { formatDate, formatNumCommande } from './OrderAction';
import Icons from './Icons';
import { MotifAnnulation, Order, PaymentMethod } from './iMonCompte';
import { PaypalCheckout } from '../payment/PaypalCheckout';
import { CBCheckout } from '../payment/CBCheckout';
import {getHostApi, getRequestConfig} from '../../utils';
import RenderCountdown from "./RenderCountdown";
import 'moment/locale/fr';
import {getShopInfosInStorage} from "../cart/ShopInfos";
import {PaypalCheckoutV2} from "../payment/PaypalCheckoutV2";
import Rib from './Rib';

interface RenderOrderLineState {
  showAlert: boolean;
  textAlert: string;
  classAlert: string;
  open: boolean;
  openRIB: boolean;
  openCheque: boolean;
  motifAnnulation: string;
  autreMotif: string;
  order: Order;
  oldOrder: boolean;
}

interface RenderOrderLineProps {
  order: Order;
  paymentMethods: PaymentMethod[];
  activateAnnulation: boolean;
  activateNewUpload: boolean;
  oldOrder: boolean;
  motifsAnnulation: MotifAnnulation[];
  fromSplitOrder: boolean;
}

export default class RenderOrderLine extends React.Component<RenderOrderLineProps, RenderOrderLineState> {
  constructor(props: RenderOrderLineProps) {
    super(props);
    this.state = {
      showAlert: false,
      textAlert: 'Votre adresse a bien été mise à jour',
      classAlert: 'alert-success',
      open: false,
      openRIB: false,
      openCheque: false,
      motifAnnulation: '',
      autreMotif: '',
      order: props.order,
      oldOrder: false,
    };
  }

  /**
   * Fonction permettant de retourner une commande
   *
   * @param {string} orderId
   * @private
   */
  _getOrder = () => {
    axios.get(`${getHostApi()}/customers/${getUserId()}/orders/${this.state.order.idCommande}`, getRequestConfig())
      .then((response) => {
      if (response.data.order) {
        this.setState({ order: response.data.order });
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  /**
   * Fonction permettant d'annuler une commande
   *
   * @param {string} orderId
   * @param annulationIsPossible
   * @private
   */
  _cancelOrderOld = () => {
    if ((this.state.order.annulationInfo && this.state.order.annulationInfo.isPossible === 'Oui' &&
      this.props.activateAnnulation == true && this.state.motifAnnulation === '') ||
      this.state.motifAnnulation !== '') {

      if ((this.state.motifAnnulation === 'Autre' && this.state.autreMotif !== '') ||
        this.state.motifAnnulation !== 'Autre') {
        this.onCloseModal();
        const url = `${getHostApi()}/customers/${getUserId()}/orders/${this.state.order.idCommande}/cancel`;
        axios.put(url, { motif: this.state.motifAnnulation, autreMotif: this.state.autreMotif}, getRequestConfig())
          .then((response) => {
          this.setState({
            showAlert: true,
            textAlert: 'Votre commande a bien été annulée !',
            classAlert: 'alert-success',
          }, () => {
            this._getOrder();
          });
        }).catch((error) => {
          console.log(error);
        });
      }else {
        this.setState({
          showAlert: true,
          classAlert: 'alert-danger',
          textAlert: 'Pour annuler votre commande, merci de bien vouloir nous indiquer la raison.',
        });
      }
    } else {
      this.setState({
        showAlert: true,
        classAlert: 'alert-danger',
        textAlert: 'Pour annuler votre commande, merci de bien vouloir nous indiquer la raison.',
      });
    }
  }

  _cancelOrder = () => {
    if (this.state.order.annulationInfo && this.state.order.annulationInfo.isPossible === 'Oui') {
      if ((this.props.motifsAnnulation.length > 0 && this.state.motifAnnulation !== '' &&
        (this.state.motifAnnulation !== '10' ||
          (this.state.motifAnnulation === '10' && this.state.autreMotif !== ''))) ||
        (this.props.motifsAnnulation.length === 0 && this.state.autreMotif !== '')) {
        this.onCloseModal();
        const url = `${getHostApi()}/customers/${getUserId()}/orders/${this.state.order.idCommande}/cancel`;
        axios.put(url, { motif: this.state.motifAnnulation, autreMotif: this.state.autreMotif }, getRequestConfig())
          .then((response) => {
          this.setState({
            showAlert: true,
            textAlert: 'Votre commande a bien été annulée !',
            classAlert: 'alert-success',
          }, () => {
            this._getOrder();
          });
        }).catch((error) => {
          console.log(error);
        });
      }else {
        this.setState({
          showAlert: true,
          classAlert: 'alert-danger',
          textAlert: 'Pour annuler votre commande, merci de bien vouloir nous indiquer la raison.',
        });
      }
    } else {
      this.setState({
        showAlert: true,
        classAlert: 'alert-danger',
        textAlert: 'L\'annulation de la commande n`\'est pas autorisée',
      });
    }
  }

  /**
   * Fonction permettant de mettre à jour le moyen de paiement d'une commande
   *
   * @param {string} reglement
   * @param {string} orderId
   * @private
   */
  _updatePaymentMethodOrder = (reglement: string) => {
    const url = `${getHostApi()}/customers/${getUserId()}/orders/${this.state.order.idCommande}/reglement`;
    axios.put(url, { reglement: reglement }, getRequestConfig())
      .then((response) => {
      this.setState({
        showAlert: true,
        textAlert: 'Le mode de règlement a bien été mis à jour !',
        classAlert: 'alert-success',
      }, () => {
        this._getOrder();
      });
    }).catch((error) => {
      console.log(error);
      this.setState({
        showAlert: true,
        textAlert: 'Une erreur est survenue pendant la modification de votre mode de règlement !',
        classAlert: 'alert-danger',
      });
    });
  }

  _handleChangePaymentMode = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (event.target.value !== 'annulerCommande') {
      if (event.target.value === 'Bon de commande administratif') {
        event.target.value = 'Virement Administration';
      }
      this._updatePaymentMethodOrder(event.target.value);
    } else {
      this.onOpenModal();
    }
  }

  onOpenModal = () => {
    this.setState({ open: true });
  }

  onOpenModalRIB = () => {
    this.setState({
      openRIB: true,
    });
  }

  onOpenModalCheque = () => {
    this.setState({
      openCheque: true,
    });
  }

  onCloseModal = () => {
    this.setState({ open: false });
  }

  onCloseModalRIB = () => {
    this.setState({ openRIB: false });
  }

  onCloseModalCheque = () => {
    this.setState({ openCheque: false });
  }

  handleOnPaymentConfirmed = () => {
    this._getOrder();
  }

  _defineCLassOld = () => {
    if (this.props.oldOrder) {
      return 'old-order pa0';
    }

    return '';
  }
  _onChangeAutreMotif = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    this.setState({ autreMotif: event.target.value });
  }

  _onChangeMotifAnnulation = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    this.setState({ motifAnnulation: event.target.value });
    const textarea = document.getElementById('autre_motif');

    if(!textarea) return;

    if (event.target.value === '10') {
      textarea.style.display = 'block';
    } else {
      textarea.style.display = 'none';
    }

  }

  _onUpdateDateLivraisonPrevue = (dateLivraison: string) => {
    this.setState({
      order:{
        ...this.state.order,
        date_livraison_prevue: dateLivraison,
      },
    });
  }

  render() {

    const renderSelectMotifs = () => {
      if (this.props.motifsAnnulation.length > 0) {
        const motifsFiltered = this.props.motifsAnnulation.filter(item => parseInt(item.droits,10) === 0 && parseInt(item.is_avoir,10) === 0);
        return (
          <div className="mb-3">
            <select id="motifAnnulation" name="motifAnnulation" onChange={(e: any) => this._onChangeMotifAnnulation(e)}>
              <option key="motif-default" value="" selected className="grey italic">Sélectionnez la raison de votre annulation</option>
              {motifsFiltered.map(motif => (
                <option key={`motif-${motif.id}`} id={motif.id} value={motif.id}>{motif.motif}</option>
              ))}
            </select>
          </div>
        );
      }
    };

    const renderTextareaMotif = () => {
      return (
        <div className="mb-3">
          <textarea placeholder="Précisez la raison de votre annulation" name="autre_motif" id="autre_motif"
                    cols={70} style={{ display: this.props.motifsAnnulation.length === 0 ? 'block' : 'none' }} 
                    onChange={e => this._onChangeAutreMotif(e)}></textarea>
        </div>
      );
    };

    const renderCancelModal = () => {
      return (
        <Modal open={ this.state.open } onClose={ this.onCloseModal } center
               classNames={{overlay: 'bootstrap-container', modal: 'cancelOrderModalContainer customModal', closeButton: 'cancelOrderModalCloseButton' +
                   ' closeButton'}}>
          <div className="modalOrder p-2 pa0Mobile">
            <p className="bold text-underline font18">
              Etes-vous sûr de vouloir annuler la commande {formatNumCommande(this.state.order.numCommande)} ?
            </p>
            {renderAlert(this.state.showAlert, this.state.classAlert, this.state.textAlert)}
            {renderSelectMotifs()}
            {renderTextareaMotif()}
            <button title="Annuler" onClick={ this.onCloseModal }
                    className="border-0 bold bg-white1 cursor-pointer btnCancelModal float-left py-2 px-3">
              Non
            </button>
            <button title="Annuler la commande" onClick={ this._cancelOrder }
                    className="border border-dark bold bg-white1 cursor-pointer btnValidateModal float-right py-2 px-3">
              Oui
            </button>
          </div>
        </Modal>
      );
    };

    /*const renderDateSouhaitee = () => {
      if (this.state.order.DateSouhaite !== '0000-00-00') {
        return (
          <span className="">&nbsp;le { formatDate(this.state.order.DateSouhaite) }</span>
        );
      }
    };*/

    const renderDateLivraisonPrevue = () => {
      if (this.state.order.date_livraison_prevue !== '0000-00-00') {
        return (
          <span className="">&nbsp;le { formatDate(this.state.order.date_livraison_prevue) }</span>
        );
      } else { // Pour les commandes dont le champ date_livraison_prevue est encore nul avant la mise en prod
        return (
          <span className="">&nbsp;le { formatDate(this.state.order.DateSouhaite) }</span>
        );
      }
    };

    const renderLivraisonPrevue = () => {
      if (this.state.order.cf !== '1' && this.state.order.DateSouhaite !== '0000-00-00' && this.state.order.StatutCommande != '9') {
        return (
          <div>
            <span>Livraison prévue</span>{ renderDateLivraisonPrevue() }
          </div>
        );
      }
    };

    const renderCol1 = () => {
      const defineClass = () => {
        if (getShopRefInStorage() === 'TE' || getShopRefInStorage() === 'TO' || getShopRefInStorage() === 'TH' || getShopRefInStorage() === 'DT') {
          return 'col-md-3';
        }
        return 'col-md-4';
      };

      const renderIcSAV = (sav: string) => {
        if (sav == '1') {
          return (
            <span title="Commande issue d'une réclamation" className="mr-2 cursor-help">
              <Icons icon="build" size={ 12 } color="#333"/>
            </span>
          );
        }
      };

      return (
        <div className={ defineClass() + ' pl-0 pa0Mobile' }>
          <div className="flex-row-mobile align-items-center justify-content-between">
            <div className="grey font14">
              { renderIcSAV(this.state.order.sav) }
              <Link className="grey text-underline" title="Détail de la commande"
                    to={ `/orders/${this.state.order.idCommande}` }>
                { renderNumCommande(this.state.order.numCommande) }
              </Link>
            </div>
            <div className="bold">
              { renderDateCommande(this.state.order.numCommande, this.state.order.DateDeCommande, 'Date') }
            </div>
          </div>
          <div className="flex-row-mobile align-items-center justify-content-between">
            { renderLivraisonPrevue() }
            { renderClaim(this.state.order) }
          </div>
        </div>
      );
    };

    const renderSelectModeReglement = () => {
      if (this.state.order.StatutCommande < '3' && this.state.order.annulationInfo) {
        return (
          <div>
            <select value={ this.state.order.ModeDeReglement } id={ this.state.order.idCommande }
                    className={ formatNumCommande(this.state.order.numCommande) + ' small mb-2' }
                    onChange={ this._handleChangePaymentMode }>
              { renderOptionModeReglement(this.props.paymentMethods, false, this.state.order.annulationInfo.isPossible,
                this.props.activateAnnulation, parseInt(this.state.order.Pays_idPays,10)) }
            </select>

          </div>
        );
      }
    };

    const renderOrderStatus = () => {
      let link = `/orders/${this.state.order.idCommande}`;
      let target = null;
      let typeCountdown = null;
      if (isFichierAttenteValidation(
        this.state.order.StatutCommande,
        this.state.order.confirmationFichier)) {
          link = `/files/${this.state.order.idCommande}`;
        target = '_self';
        typeCountdown = "Fichier";
      } else if (isBatAttenteValidation(
        this.state.order.StatutCommande,
        this.state.order.validation_bat,
        this.state.order.confirmationFichier,
        this.state.order.MarquageClair)) {
         // link = `/../mes-bat.php?numCommande=${this.state.order.numCommande}`;
         link = `/bat/${this.state.order.idCommande}`;
        // target = '_self';
        typeCountdown = "BAT";
      }

      return (
        <>
          <Link to={ link } className="d-flex align-items-center black" target={ target as any }>
            <span>{ renderEtatCommande(
              this.state.order.StatutCommande,
              this.state.order.etat.Etat,
              this.state.order.validation_bat,
              this.state.order.confirmationFichier,
              this.state.order.MarquageClair,
              this.state.order.AucunMarquage) }</span>
          </Link>
          {typeCountdown !== null && (this.state.order as any).infosCompteur && !this.state.order.AucunMarquage &&
          <RenderCountdown type={typeCountdown} idCommande={this.state.order.idCommande}
            onChangeDateLivraison={this._onUpdateDateLivraisonPrevue} dateLivraisonPrevue={this.state.order.date_livraison_prevue !== '0000-00-00' ? this.state.order.date_livraison_prevue : this.state.order.DateSouhaite}
            infosCompteur={(this.state.order as any).infosCompteur} orderline={true}/>
          }
        </>
      );
    };

    const renderCol2 = () => {
      const defineClass = () => {
        if (getShopRefInStorage() === 'TE' || getShopRefInStorage() === 'TO' || getShopRefInStorage() === 'TH' || getShopRefInStorage() === 'DT') {
          return 'col-md-3';
        }
        return 'col-md-4';
      };

      return (
        <div className={ defineClass() + ' p-0 ' }>
          <div className="d-flex flex-column d-md-block align-items-center justify-content-between">
            { renderOrderStatus() }
            { renderSelectModeReglement() }
            { renderCancelModal() }
            { displayInvoice(this.state.order) }
            { displayRefundInformations(this.state.order) }
          </div>

          <div className="mt05Mobile">
            { renderCreditLinks(this.state.order) }
            { renderContainerTrackingLink(this.state.order.url_tracking, this.state.order.numColis, this.state.order.cf,
              this.state.order.StatutCommande, this.state.order.colis) }
          </div>

        </div>
      );
    };

    const renderModePaiement = () => {
      if (this.state.order.ModeDeReglement === 'Virement') {
        return 'Virement bancaire';
      }
      if (this.state.order.ModeDeReglement === 'Virement Administration') {
        return 'Bon de commande administratif';
      }
      if (this.state.order.ModeDeReglement === 'Cheque' || this.state.order.ModeDeReglement === 'Chèque') {
        return 'Chèque';
      }
    };

    const renderNote = (): string => {
      return this.state.order.ModeDeReglement === 'Virement' ? 
        'NOTE : Votre commande sera prise en compte dès réception du virement sur notre compte bancaire.' :
        '';
    };

    const renderInfosAPreciser = () => {
      if (this.state.order.ModeDeReglement === 'Virement') {
        return (
          <p className="orange border-orange p-2">
            Veuillez spécifier le&nbsp;
            <span className="bold">
                numéro de votre commande : {renderNumCommande(this.state.order.numCommande)}
              </span> dans le libellé de votre virement.
          </p>
        );
      }
    };

    const renderModalRIB = () => {
      return (
        <Modal open={ this.state.openRIB } onClose={ this.onCloseModalRIB } center
               classNames={{overlay: 'bootstrap-container', modal: 'ribModalContainer customModal', closeButton: 'ribModalCloseButton closeButton'}}>
          <div className="modalOrder pa0Mobile">
            <p>Vous avez choisi le mode de règlement par {renderModePaiement()}. </p>
            { renderInfosAPreciser() }
            { <Rib note={ renderNote()}/> }
          </div>
        </Modal>
      );
    };

    const renderModalCheque = () => {
      return (
        <Modal open={ this.state.openCheque } onClose={ this.onCloseModalCheque } center
               classNames={{overlay: 'bootstrap-container', modal: 'chequeModalContainer customModal', closeButton: 'chequeModalCloseButton closeButton'}}>
          <div className="modalOrder pa0Mobile">
            <p>Vous avez choisi le mode de règlement par {renderModePaiement()}.</p>
            { renderCheque(this.state.order.numCommande) }
          </div>
        </Modal>
      );
    };

    const defineButtonAction = () => {
      if (Number(this.state.order.StatutCommande) < 3) {
        if (this.state.order.ModeDeReglement === 'Cheque' || this.state.order.ModeDeReglement === 'Chèque') {
          return (
            <a className="detailsButton payButton small" onClick={ this.onOpenModalCheque }>
              Détails
            </a>
          );
        }
        if (this.state.order.ModeDeReglement === 'Virement' ||
          this.state.order.ModeDeReglement === 'Virement Administration') {
          return (
            <a className="detailsButton payButton small" onClick={ this.onOpenModalRIB }>
              Détails
            </a>
          );
        }
      }

      if (this.state.order.StatutCommande !== '9' && this.state.order.StatutCommande >= '5' && 
        this.state.order.DateDeReglement != '0000-00-00 00:00:00') {
        return (
          <div>
            <p className="black small bold ma0Mobile text-left">
              <Icons icon="done" size={ 10 } color="#73ad22"/>
              <span className="pl-1">Payé par { this.state.order.ModeDeReglement }</span>
            </p>
          </div>
        );
      }
    };

    const renderCol3 = () => {
            const usePaypalV2 = getShopInfosInStorage() && getShopInfosInStorage().paypal_v2 ? getShopInfosInStorage().paypal_v2 : false;

      const defineClass = () => {
        if (getShopRefInStorage() === 'TE' || getShopRefInStorage() === 'TO' || getShopRefInStorage() === 'MT' ||
          getShopRefInStorage() === 'ME' || getShopRefInStorage() === 'DT' || getShopRefInStorage() === 'TH') {
          return 'col-md-2';
        }
        return 'col-md-3';
      };

      if (this.state.order.sav && this.state.order.sav === '1') {
        return (
          <div className="text-center small italic">
            Commande issue d'une réclamation </div>
        );
      }
      return (
        <div className={ defineClass() + ' text-center flex-row-reverse-mobile align-items-center' +
        ' justify-content-between pa0Mobile' }>
          { renderMontantTTC(this.state.order.TotalTTC, false) }

          { this.state.order.StatutCommande < '3' && this.state.order.ModeDeReglement === 'PayPal' &&
            <>
              {usePaypalV2
                ? <PaypalCheckoutV2 onPaymentConfirmed={this.handleOnPaymentConfirmed} containerId={ 'paypal-' + this.state.order.idCommande } orderId={ this.state.order.idCommande }/>
                : <PaypalCheckout containerId={ 'paypal-' + this.state.order.idCommande } orderId={ this.state.order.idCommande } onPaymentConfirmed={ this.handleOnPaymentConfirmed }/>
              }
            </>
          }
          { this.state.order.StatutCommande < '3' && this.state.order.ModeDeReglement === 'Carte bancaire' &&
          <CBCheckout orderId={ parseInt(this.state.order.idCommande) }/>
          }

          { displayDetailsPaymentButton(this.state.order, renderModalCheque(), renderModalRIB(), defineButtonAction()) }
        </div>
      );
    };

    const renderCol4 = () => {
      const canUploadFiles = this.state.order && (getShopInfosInStorage().Ref !== 'DT' || (getShopInfosInStorage().Ref === 'DT' && this.state.order.StatutCommande && this.state.order.StatutCommande === '5' && this.state.order.confirmationFichier === '0' ));
      if(canUploadFiles) {
        return (
          <div className="col-md-3 pr-0 small bold text-center pa0Mobile ma0Mobile mt05Mobile">
            {renderFileButton(this.state.order, false, this.props.activateNewUpload)}
          </div>
        );
      } else {
        return (
          <div></div>
        )
      }
    };

    const displayCol4 = () => {
      if (getShopRefInStorage() === 'TE' || getShopRefInStorage() === 'TO' || getShopRefInStorage() === 'TH' || getShopRefInStorage() === 'DT') {
        return renderCol4();
      }
    };

    const renderCol5 = () => {
      return (
        <div className="col-md-1 px-0 overDetailCmd text-right display-mobile-none">
          <Link title={ 'Détails de la commande ' + formatNumCommande(this.state.order.numCommande) }
                className="black d-block big" to={ `/orders/${this.state.order.idCommande}` }>
            <Icons icon="keyboard_arrow_right" size={ 30 } color="black"/>
          </Link>
        </div>
      );
    };

    const renderOrder = () => {
      return (
        <div className="d-flex flex-column">
          <div className="col-md-12 p-0">
            { renderAlert(this.state.showAlert, this.state.classAlert, this.state.textAlert) }
          </div>
          <div className="col-md-12 d-flex flex-row justify-content-between align-items-center p-0 flex-column-mobile font14">
            { renderCol1() }
            { renderCol2() }
            { renderCol3() }
            { displayCol4() }
            { renderCol5() }
          </div>
        </div>
      );
    };

    return (
      <div key={ this.state.order.idCommande } className={ `row-order p-3 ${this._defineCLassOld()} ${this.props.fromSplitOrder ? ' pl-4 ' : ''}`}>
        { renderOrder() }
      </div>
    );
  }
}
